/**
 * 取两个用户信息数组的并集
 * @param arr1 用户信息数组1
 * @param arr2 用户信息数组2
 * @returns {*} 并集集合的数组
 */
export function getUnionArray(arr1, arr2) {
  const union = arr1.concat(arr2)
  for (let i = 0; i < union.length; i++) {
    for (let j = i + 1; j < union.length; j++) {
      if ((union[i].uid ? union[i].uid : union[i].id) === (union[j].uid ? union[j].uid : union[j].id)) {
        union.splice(j, 1)
        j--
      }
    }
  }
  return union
}
